/**
 * Granular permission keys for organization members.
 * Used with has_permission(org_id, key) in RLS and usePermission() in frontend.
 */
export const PERMISSION_KEYS = [
  "can_view_financials",
  "can_manage_content",
  "can_manage_events",
  "can_manage_contacts",
  "can_manage_media",
  "can_manage_team",
  "can_manage_settings",
  // Sponsor-org keys (NOS-163): govern access to sponsored child orgs.
  // Role defaults come from has_permission(): owner/admin true, editor/viewer false.
  "can_view_child_financials",
  "can_manage_child_orgs",
  "can_manage_child_content",
] as const

export type PermissionKey = (typeof PERMISSION_KEYS)[number]

export const PERMISSION_LABELS: Record<PermissionKey, string> = {
  can_view_financials: "View financial data",
  can_manage_content: "Manage website content",
  can_manage_events: "Manage events",
  can_manage_contacts: "Manage contacts",
  can_manage_media: "Manage media library",
  can_manage_settings: "Manage org settings",
  can_manage_team: "Manage team members",
  can_view_child_financials: "View sponsored org financials",
  can_manage_child_orgs: "Manage sponsored orgs",
  can_manage_child_content: "Manage sponsored org content",
}
